import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/utils/css";

// Pill-shaped filter dropdown used across the truck list toolbar and footer.
// Items are `{ id, text }`; an item with id "all" is treated as "no filter" and
// shows the placeholder instead of its label.
export const TruckListSelect = ({ items, value, onChange, placeholder, icon: Icon = ChevronDown, width = 160 }) => {
    const selected = items.find((item) => item.id === value);
    const isPlaceholder = !selected || selected.id === "all";

    return (
        <Listbox value={value} onChange={onChange}>
            {({ open }) => (
                <>
                    <ListboxButton
                        style={{ width }}
                        className="flex h-10 items-center justify-between gap-1 rounded-[20px] border border-cm-p-outline bg-cm-p-surface-container px-4 outline-none"
                    >
                        <span
                            className={cn(
                                "truncate text-[15px]",
                                isPlaceholder ? "font-normal text-cm-p-text-secondary" : "font-medium text-cm-p-text-primary",
                            )}
                        >
                            {isPlaceholder ? placeholder : selected.text}
                        </span>
                        <Icon
                            className={cn("h-4 w-4 shrink-0 text-cm-p-text-secondary transition-transform", {
                                "rotate-180": open && Icon === ChevronDown,
                            })}
                        />
                    </ListboxButton>
                    <ListboxOptions
                        anchor="bottom start"
                        className="z-dropdown mt-2 min-w-[160px] rounded-lg border border-cm-p-outline bg-cm-p-surface p-1 shadow-[0_4px_8px_rgba(0,0,0,0.08)]"
                    >
                        {items.map((item) => (
                            <ListboxOption
                                key={item.id}
                                value={item.id}
                                className="flex min-h-[38px] cursor-pointer items-center rounded-md px-3 text-sm font-medium text-cm-p-text-primary data-[focus]:bg-cm-p-surface-hover"
                            >
                                {item.text}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </>
            )}
        </Listbox>
    );
};
